<div class="ui-g" [formGroup]="parentForm">
  <div class="ui-g-9">
    <div class="ui-g m-b-0">
      <div class="ui-g-offset-4 ui-g-8">
        <h3 class="m-t-0">
          {{ 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.CONSTITUTION' | translate }}
        </h3>
      </div>
    </div>
    <div class="ui-g"
         *gsShowIfHasPermission="['ORGANIZATION_CONSTITUTION_RECEIVED_READ']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.CONSTITUTION_RECEIVED' | translate }}</label>
      </div>
      <div class="ui-g-8">
        <wsd-extended-input [control]="parentForm.get('constitutionReceived')">
          <p-radioButton [value]="true"
                         name="constitutionReceived"
                         formControlName="constitutionReceived"
                         label="{{ 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.YES' | translate }}"
                         labelStyleClass="p-radiobutton-label-constitution"
                         [style.margin-right]="'20px'"
                         [style.padding-top]="'15px'"
                         [style.padding-bottom]="'10px'">

          </p-radioButton>
          <p-radioButton [style.padding-bottom]="'10px'"
                         [value]="false"
                         name="constitutionReceived"
                         formControlName="constitutionReceived"
                         label="{{ 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.NO' | translate }}"
                         labelStyleClass="p-radiobutton-label-constitution">
          </p-radioButton>
        </wsd-extended-input>
      </div>
    </div>
    <div class="ui-g m-b-0"
         *gsShowIfHasPermission="['ORGANIZATION_CONSTITUTION_YEAR_READ']">
      <div class="ui-g-4">
        <label>{{ 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.LAST_YEAR' | translate }}</label>
      </div>
      <div class="ui-g-4">
        <wsd-extended-input [control]="parentForm.get('constitutionApprovalYear')">
          <p-dropdown
            [options]="years"
            formControlName="constitutionApprovalYear">
          </p-dropdown>
        </wsd-extended-input>
      </div>
    </div>
  </div>

  <div class="ui-g-12"
       *gsShowIfHasPermission="['ORGANIZATION_POLICY_INFORMATION_READ']">
    <div class="ui-g">
      <div class="ui-g-offset-3 ui-g-9">
        <h3 class="m-t-0">
          {{ 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.POLICY_DOCUMENTS' | translate }}
        </h3>
      </div>
    </div>
    <div class="ui-g m-b-0">
      <div class="ui-g-offset-3 ui-g-9"
           *ngFor="let entry of policyDocuments; trackBy: trackByIdentity">
        <div class="p-grid m-b-0">
          <div class="p-col">
            {{ entry.documentName }}
          </div>
          <div class="p-col text-right">
            <p-radioButton [label]=" 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.YES' | translate "
                           [value]="true"
                           [disabled]="documentsDisabled"
                           [ngModelOptions]="{standalone: true}"
                           [(ngModel)]="entry.state"
                           [name]="'answer_' + entry.id"
                           class="m-r-15 inline-block m-b-0">
            </p-radioButton>
            <p-radioButton [label]=" 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.NO' | translate "
                           [value]="false"
                           [disabled]="documentsDisabled"
                           [ngModelOptions]="{standalone: true}"
                           [(ngModel)]="entry.state"
                           [name]="'answer_' + entry.id"
                           class="m-r-15 inline-block m-b-0">
            </p-radioButton>
            <p-radioButton [label]=" 'WS_DIRECTORY.ORG_MODIFY.CONST_POLICIES.DONT_KNOW' | translate "
                           [value]="null"
                           [disabled]="documentsDisabled"
                           [ngModelOptions]="{standalone: true}"
                           [(ngModel)]="entry.state"
                           [name]="'answer_' + entry.id"
                           class="m-r-15 inline-block m-b-0">
            </p-radioButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
